import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import { orderDateStyles } from "@dana/Overrides/Widgets/OrderDetails/OrderDate";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

orderDateStyles.wrapper = mergeToNew(orderDateStyles.wrapper, {
    width: [12, 12, 12, 12, 12],
    css: css`
        display: flex;
        flex-direction: column;
        padding: 0px;
    `,
});

orderDateStyles.titleText = mergeToNew(orderDateStyles.titleText, {
    variant: "h3",
    css: css`
        margin-bottom: 0px;
        background: ${themeBackgrounds.lightGray};
        padding: 16px;
        width: 100%;
    `,
});

orderDateStyles.orderDate = mergeToNew(orderDateStyles.orderDate, {
    css: css`
        padding: 4px;
    `,
});
